const cachebusting = "?d=" + Date.now();
export default cachebusting;